<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Policy from 'dashboard/components/policy.vue';

import { computed } from 'vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'approved',
    validator: value => ['approved', 'pending'].includes(value),
  },
  hasActiveFilters: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click', 'clearFilters']);

const isApproved = computed(() => props.variant === 'approved');
const isPending = computed(() => props.variant === 'pending');

const onClick = () => {
  emit('click');
};

const onClearFilters = () => {
  emit('clearFilters');
};
</script>

<template>
  <div
    class="flex min-h-96 flex-col items-center justify-center px-6 text-center"
  >
    <span
      class="mb-4 flex size-11 items-center justify-center rounded-lg bg-n-alpha-2 text-n-slate-11"
    >
      <span class="i-lucide-message-square-text size-5" />
    </span>
    <h2 class="mb-1 text-base font-semibold text-n-slate-12">
      {{
        isPending
          ? $t('CAPTAIN.RESPONSES.EMPTY_STATE.NO_PENDING_TITLE')
          : $t('CAPTAIN.RESPONSES.EMPTY_STATE.TITLE')
      }}
    </h2>
    <p v-if="isApproved" class="mb-4 max-w-md text-sm text-n-slate-10">
      {{ $t('CAPTAIN.RESPONSES.EMPTY_STATE.SUBTITLE') }}
    </p>
    <Policy v-if="isApproved" :permissions="['administrator']">
      <Button
        :label="$t('CAPTAIN.RESPONSES.ADD_NEW')"
        icon="i-lucide-plus"
        size="sm"
        @click="onClick"
      />
    </Policy>
    <Button
      v-else-if="isPending && hasActiveFilters"
      :label="$t('CAPTAIN.RESPONSES.EMPTY_STATE.CLEAR_SEARCH')"
      variant="link"
      size="sm"
      @click="onClearFilters"
    />
  </div>
</template>
